
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/all-components",
      function () {
        return require("private-next-pages/x/react-chat/all-components.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/all-components"])
      });
    }
  